// extracted by mini-css-extract-plugin
module.exports = {"CowTagNumber":"CowTagNumber--3OX_k","Table":"Table--3Hp_e","Small":"Small--25JPj","HighRisk":"HighRisk--2dxZr","MediumRisk":"MediumRisk--1TNHO","LowRisk":"LowRisk--22u8e"};